import React from 'react'
import FeatureTable from './components/FeatureTable'
import platformIcon from './images/platform.png'
import { Cell, CheckCell, ValueCell } from './components/ValueCell'

const Platform = () => {
  return (
    <FeatureTable title="平台能力" icon={platformIcon}>
      <>
        <tr>
          <Cell>应用创建数量</Cell>
          <ValueCell>2个</ValueCell>
          <ValueCell>5个</ValueCell>
          <ValueCell>10个</ValueCell>
          <ValueCell>20个</ValueCell>
        </tr>
        <tr>
          <Cell>X-SDK 代码集成</Cell>
          <CheckCell />
          <CheckCell />
          <CheckCell />
          <CheckCell />
        </tr>
        <tr>
          <Cell>Web/H5/网站支持</Cell>
          <CheckCell />
          <CheckCell />
          <CheckCell />
          <CheckCell />
        </tr>
        <tr>
          <Cell>APP/小程序支持</Cell>
          <ValueCell />
          <CheckCell />
          <CheckCell />
          <CheckCell />
        </tr>
        <tr>
          <Cell>团队协作账户</Cell>
          <ValueCell></ValueCell>
          <ValueCell>10个/应用</ValueCell>
          <ValueCell>20个/应用</ValueCell>
          <ValueCell>50个/应用</ValueCell>
        </tr>
        {['用户群组', '推送至企业微信、钉钉、飞书', 'Webhook 与数据 API'].map((item, index) => (
          <tr key={index}>
            <Cell>{item}</Cell>
            <ValueCell />
            <CheckCell />
            <CheckCell />
            <CheckCell />
          </tr>
        ))}
        <tr>
          <Cell>隐藏浩客品牌标识</Cell>
          <ValueCell />
          <ValueCell />
          <CheckCell />
          <CheckCell />
        </tr>
      </>
    </FeatureTable>
  )
}

export default Platform
